export default "__VITE_ASSET__Bki0euph__"